import React, { useState } from 'react';
import { AutoAwesome } from '@mui/icons-material';
import './CriteriaIconImg.css';

/**
 * Criterion icon shared by the desktop chips and the mobile sheet: renders the
 * <img>, or `fallback` when there is no src / the src fails to load.
 *
 * `spark` is for a criterion that stands for no single item — "find the best
 * weapon" wears the slot it means to fill, under the generator's own sparkles,
 * because the weapon slot's placeholder alone read as a weapon the build
 * already has.
 *
 * Deliberately NOT MediaImg: these icons are `position: absolute; inset: 0`
 * inside their slot, and MediaImg's wrapper span would capture that positioning
 * — un-breaking it would mean styling `.media-img` from a foreign stylesheet.
 * So this renders the element directly, with no wrapper, which also keeps the
 * mobile summary's child-by-child width measurement working. `spark` is the one
 * case that needs a wrapper, and it takes the caller's class itself so the pair
 * sits exactly where the single icon did.
 *
 * Src resolution belongs upstream in useCriteriaAndScore; this only covers
 * icons that resolve fine but still fail to load.
 */
const CriteriaIconImg = ({ src, spark = false, fallback = null, ...imgProps }) => {
    const [brokenSrc, setBrokenSrc] = useState(null);

    if (!src || brokenSrc === src) return fallback;

    const image = (
        <img
            src={src}
            alt=""
            {...(spark ? { className: 'criteria-icon-spark__img' } : imgProps)}
            onError={() => setBrokenSrc(src)}
        />
    );

    if (!spark) return image;

    const { className, ...rest } = imgProps;
    return (
        <span className={`criteria-icon-spark${className ? ` ${className}` : ''}`} {...rest}>
            {image}
            <AutoAwesome className="criteria-icon-spark__mark" />
        </span>
    );
};

export default CriteriaIconImg;
